'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../styleInject.js');

var css_248z = ".DeliveryHistory-module_container__5-EpU{width:100%}";
var styles = {"container":"DeliveryHistory-module_container__5-EpU"};
styleInject["default"](css_248z, 'd886966d-5ffb-4a73-93f6-62c663b7a62f');

exports["default"] = styles;
